import store from '@/store'
import { useRouter } from '@core/utils/utils'
import Vue from 'vue'
import useNotificacion from '../notificacion/useNotificacion'

export default () => {
  const { loadNotifications } = useNotificacion()
  const { router, route } = useRouter()

  const setConfig = obj => store.dispatch('cuenta/postForm', obj)
  //* Load roles list
  const loadRoles = () => store.dispatch('cuenta/get_roles')

  //* Change actual user's rol
  const updateCurrentRole = rolSelected => {
    Vue.prototype.$currentRol = rolSelected.id // * Update current rol (global var)
    const redirectTo = rolSelected.base_path ? rolSelected.base_path : '/' //* Get role's base path
    store.dispatch('cuenta/upd_rolSelected', rolSelected) //* Update user's rol
    if (route.value.path !== redirectTo) router.push(redirectTo) //* Redirect to new base path depending the rol selected
    loadNotifications()
  }

  return {
    loadRoles,
    updateCurrentRole,
    setConfig,
  }
}
